/* tslint:disable */
export const PathRootJson = {
  "data":{
    "id":"1",
    "type":"syllabus-nodes",
    "links":{
      "self":"/api/v1/lms/syllabus-nodes/1"
    },
    "attributes":{
      "title":"Interact Syllabus",
      "description":"Interact Syllabus",
      "syllabus-node-type":"syllabus"
    },
    "relationships":{
      "tasks":{
        "links":{
          "self":"/api/v1/lms/syllabus-nodes/1/relationships/tasks",
          "related":"/api/v1/lms/syllabus-nodes/1/tasks"
        }
      },
      "syllabus-nodes":{
        "links":{
          "self":"/api/v1/lms/syllabus-nodes/1/relationships/syllabus-nodes",
          "related":"/api/v1/lms/syllabus-nodes/1/syllabus-nodes"
        },
        "data":[
          {
            "type":"syllabus-nodes",
            "id":"2"
          },
          {
            "type":"syllabus-nodes",
            "id":"7"
          },
          {
            "type":"syllabus-nodes",
            "id":"8"
          },
          {
            "type":"syllabus-nodes",
            "id":"9"
          },
          {
            "type":"syllabus-nodes",
            "id":"10"
          },
          {
            "type":"syllabus-nodes",
            "id":"11"
          }
        ]
      }
    }
  },
  "included":[
    {
      "id":"19",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/19"
      },
      "attributes":{
        "title":"This is a test subtask",
        "description":"testing stuff",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/19/relationships/tasks",
            "related":"/api/v1/lms/tasks/19/tasks"
          }
        }
      }
    },
    {
      "id":"1",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/1"
      },
      "attributes":{
        "title":"Prepare to Face the GMAT: Part 1",
        "description":"Interact lesson",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/1/relationships/tasks",
            "related":"/api/v1/lms/tasks/1/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"19"
            }
          ]
        }
      }
    },
    {
      "id":"20",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/20"
      },
      "attributes":{
        "title":"This is a test subtask 2",
        "description":"This is a description.....wooot",
        "resource-id":0
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/20/relationships/tasks",
            "related":"/api/v1/lms/tasks/20/tasks"
          }
        }
      }
    },
    {
      "id":"2",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/2"
      },
      "attributes":{
        "title":"Course Overview",
        "description":"Interact lesson",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/2/relationships/tasks",
            "related":"/api/v1/lms/tasks/2/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"20"
            }
          ]
        }
      }
    },
    {
      "id":"21",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/21"
      },
      "attributes":{
        "title":"This is a test subtask 24",
        "description":"Well....Here is another one!",
        "resource-id":0
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/21/relationships/tasks",
            "related":"/api/v1/lms/tasks/21/tasks"
          }
        }
      }
    },
    {
      "id":"3",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/3"
      },
      "attributes":{
        "title":"Take your 1st practice CAT exam",
        "description":"CAT exam",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/3/relationships/tasks",
            "related":"/api/v1/lms/tasks/3/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"21"
            }
          ]
        }
      }
    },
    {
      "id":"4",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/4"
      },
      "attributes":{
        "title":"Read the Welcome Guide",
        "description":"Reading",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/4/relationships/tasks",
            "related":"/api/v1/lms/tasks/4/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"5",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/5"
      },
      "attributes":{
        "title":"Do Chapter 1 Drill Sets, odd-numbered problems (p. 49)",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/5/relationships/tasks",
            "related":"/api/v1/lms/tasks/5/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"6",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/6"
      },
      "attributes":{
        "title":"Do Chapter 4 Drill Sets, odd-numbered problems (pp. 181-183)",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/6/relationships/tasks",
            "related":"/api/v1/lms/tasks/6/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"7",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/7"
      },
      "attributes":{
        "title":"Do Chapter 5 Drill Sets, odd-numbered problems (pp. 229-233)",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/7/relationships/tasks",
            "related":"/api/v1/lms/tasks/7/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"8",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/8"
      },
      "attributes":{
        "title":"Do and review the following problems",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/8/relationships/tasks",
            "related":"/api/v1/lms/tasks/8/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"9",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/9"
      },
      "attributes":{
        "title":"Read Chapter 1 (pp. 13-20), then do odd-numbered problems on p. 21",
        "description":"Reading & Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/9/relationships/tasks",
            "related":"/api/v1/lms/tasks/9/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"10",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/10"
      },
      "attributes":{
        "title":"Read Chapter 2 (pp. 25-32), then do odd-numbered problems on p. 33",
        "description":"Reading & Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/10/relationships/tasks",
            "related":"/api/v1/lms/tasks/10/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"11",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/11"
      },
      "attributes":{
        "title":"Read Chapter 3 (pp. 37-44)",
        "description":"Reading",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/11/relationships/tasks",
            "related":"/api/v1/lms/tasks/11/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"12",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/12"
      },
      "attributes":{
        "title":"For each Official Guide problem listed below, solve using the Testing Cases method if applicable.  Otherwise solve with a different method.  Remember to review your work thoroughly.",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/12/relationships/tasks",
            "related":"/api/v1/lms/tasks/12/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"13",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/13"
      },
      "attributes":{
        "title":"Read Chapter 4 (pp. 45-54), then do odd-numbered problems on p. 55",
        "description":"Reading & Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/13/relationships/tasks",
            "related":"/api/v1/lms/tasks/13/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"14",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/14"
      },
      "attributes":{
        "title":"Read Chapter 5 (pp.59-68), then do odd-numbered problems on p. 69",
        "description":"Reading & Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/14/relationships/tasks",
            "related":"/api/v1/lms/tasks/14/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"15",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/15"
      },
      "attributes":{
        "title":"Read Appendix A: Data Sufficiency (pp. 129-147)",
        "description":"Reading",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/15/relationships/tasks",
            "related":"/api/v1/lms/tasks/15/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"16",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/16"
      },
      "attributes":{
        "title":"Read Chapter 1: The SC Process (pp. 13-24)",
        "description":"Reading",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/16/relationships/tasks",
            "related":"/api/v1/lms/tasks/16/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"17",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/17"
      },
      "attributes":{
        "title":"Read Chapter 2: Grammar & Meaning (pp. 25-34), then do odd-numbered problems on p. 35",
        "description":"Reading & Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/17/relationships/tasks",
            "related":"/api/v1/lms/tasks/17/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"18",
      "type":"tasks",
      "links":{
        "self":"/api/v1/lms/tasks/18"
      },
      "attributes":{
        "title":"Do and review the following problems",
        "description":"Problem set",
        "resource-id":1
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/tasks/18/relationships/tasks",
            "related":"/api/v1/lms/tasks/18/tasks"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"3",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/3"
      },
      "attributes":{
        "title":"Lessons",
        "description":"Lessons",
        "syllabus-node-type":"section"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/3/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/3/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"1"
            },
            {
              "type":"tasks",
              "id":"2"
            }
          ]
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/3/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/3/syllabus-nodes"
          }
        }
      }
    },
    {
      "id":"4",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/4"
      },
      "attributes":{
        "title":"General",
        "description":"General",
        "syllabus-node-type":"section"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/4/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/4/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"3"
            },
            {
              "type":"tasks",
              "id":"4"
            }
          ]
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/4/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/4/syllabus-nodes"
          }
        }
      }
    },
    {
      "id":"5",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/5"
      },
      "attributes":{
        "title":"Quant",
        "description":"Quant",
        "syllabus-node-type":"section"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/5/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/5/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"5"
            },
            {
              "type":"tasks",
              "id":"6"
            },
            {
              "type":"tasks",
              "id":"7"
            },
            {
              "type":"tasks",
              "id":"8"
            },
            {
              "type":"tasks",
              "id":"9"
            },
            {
              "type":"tasks",
              "id":"10"
            },
            {
              "type":"tasks",
              "id":"11"
            },
            {
              "type":"tasks",
              "id":"12"
            },
            {
              "type":"tasks",
              "id":"13"
            },
            {
              "type":"tasks",
              "id":"14"
            }
          ]
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/5/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/5/syllabus-nodes"
          }
        }
      }
    },
    {
      "id":"6",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/6"
      },
      "attributes":{
        "title":"Verbal",
        "description":"Verbal",
        "syllabus-node-type":"section"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/6/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/6/tasks"
          },
          "data":[
            {
              "type":"tasks",
              "id":"15"
            },
            {
              "type":"tasks",
              "id":"16"
            },
            {
              "type":"tasks",
              "id":"17"
            },
            {
              "type":"tasks",
              "id":"18"
            }
          ]
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/6/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/6/syllabus-nodes"
          }
        }
      }
    },
    {
      "id":"2",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/2"
      },
      "attributes":{
        "title":"Session 1",
        "description":"Session 1",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/2/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/2/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/2/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/2/syllabus-nodes"
          },
          "data":[
            {
              "type":"syllabus-nodes",
              "id":"3"
            },
            {
              "type":"syllabus-nodes",
              "id":"4"
            },
            {
              "type":"syllabus-nodes",
              "id":"5"
            },
            {
              "type":"syllabus-nodes",
              "id":"6"
            }
          ]
        }
      }
    },
    {
      "id":"7",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/7"
      },
      "attributes":{
        "title":"Session 2",
        "description":"Session 2",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/7/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/7/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/7/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/7/syllabus-nodes"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"8",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/8"
      },
      "attributes":{
        "title":"Session 3",
        "description":"Session 3",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/8/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/8/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/8/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/8/syllabus-nodes"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"9",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/9"
      },
      "attributes":{
        "title":"Session 4",
        "description":"Session 4",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/9/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/9/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/9/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/9/syllabus-nodes"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"10",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/10"
      },
      "attributes":{
        "title":"Session 5",
        "description":"Session 5",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/10/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/10/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/10/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/10/syllabus-nodes"
          },
          "data":[

          ]
        }
      }
    },
    {
      "id":"11",
      "type":"syllabus-nodes",
      "links":{
        "self":"/api/v1/lms/syllabus-nodes/11"
      },
      "attributes":{
        "title":"Session 6",
        "description":"Session 6",
        "syllabus-node-type":"unit"
      },
      "relationships":{
        "tasks":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/11/relationships/tasks",
            "related":"/api/v1/lms/syllabus-nodes/11/tasks"
          }
        },
        "syllabus-nodes":{
          "links":{
            "self":"/api/v1/lms/syllabus-nodes/11/relationships/syllabus-nodes",
            "related":"/api/v1/lms/syllabus-nodes/11/syllabus-nodes"
          },
          "data":[

          ]
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/shared/services/path-root.json.ts